import { lenis } from './animations';

export const initAutocomplete = () => {
  const inputContainer = document.querySelector('.js-search');

  if (!inputContainer) {
    return false
  }

  const input = inputContainer.querySelector('.js-input')
  const form = inputContainer.closest('.sk-form-search');
  const resultsContainer = form.nextElementSibling.querySelector('.js-search-automplete');
  const resultsBlock = resultsContainer.parentElement;
  const contentInner = document.querySelector('.content-inner');
  let isFetching = false;
  let typingTimer;
  const delay = 300;

  function handleResetInputValue(e) {
    if (!e.target.closest('.search-autocomplete') && 
    !e.target.closest('.js-search') && 
      !resultsBlock.classList.contains('hide')) {
        resultsBlock.classList.add('hide');
        document.body.classList.remove('open');
        lenis.start()

        if (contentInner) {
          contentInner.classList.remove('open')
        }
    }
  }

  function fetchResults(e) {
    const searchValue = e.target.value.trim();

    if (searchValue.length < 1) {
      resultsBlock.classList.add('hide');
      document.body.classList.remove('open');
      lenis.start()
      if (contentInner) {
        contentInner.classList.remove('open')
      }
      resultsContainer.innerHTML = '';
      return;
    }

    clearTimeout(typingTimer);

    typingTimer = setTimeout(async () => {
      if (isFetching) return;
      isFetching = true;

      try {
        const response = await fetch(themeVars.ajax_url, {
          method: 'POST',
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          },
          body: new URLSearchParams({
            action: 'cf_autocomplete',
            data: searchValue,
          }),
        });

        if (!response.ok) throw new Error('Network response was not ok');

        const data = await response.json();

        resultsContainer.innerHTML = '';

        if (data.data && data.data.posts && data.data.posts.length > 0) {
          resultsBlock.classList.remove('hide');
          document.body.classList.add('open');
          lenis.stop();

          if (contentInner) {
            contentInner.classList.add('open')
          }

          data.data.posts.forEach(post => {
            let li = document.createElement('li');
            let a = document.createElement('a');

            a.href = post.link;
            a.textContent = post.title;
            a.classList.add('js-autocomplete-item');

            li.appendChild(a);
            resultsContainer.appendChild(li);
          });
        } else {
          resultsBlock.classList.add('hide');
          document.body.classList.remove('open');
          lenis.start()
          if (contentInner) {
            contentInner.classList.remove('open')
          }
        }
      } catch (error) {
        console.error('Fetch error:', error);
      } finally {
        isFetching = false;
      }
    }, delay);
  }

  input.addEventListener('keyup', (e) => {
    fetchResults(e)
  });

  input.addEventListener('focus', (e) => {
    fetchResults(e)
  })

  document.addEventListener('click', (e) => {
    // handleSetInputValue(e, form)
    handleResetInputValue(e)
  })
}
